import { render, staticRenderFns } from "./LawyerDetails.vue?vue&type=template&id=90c7dd34&"
import script from "./LawyerDetails.vue?vue&type=script&lang=ts&"
export * from "./LawyerDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports